import $ from 'jquery';
export const getInputValue = ($input) => {
    if (isCheckbox($input)) {
        return $input.is(':checked');
    }
    if (isRadio($input)) {
        const $radioInput = getRadioInput($input);
        return getAssociatedInputs($radioInput).filter(':checked').val();
    }
    return $input.val();
};
export const getAssociatedInputs = ($input) => {
    return $(`input[name="${$input.attr('name')}"]`);
};
export const isCheckbox = ($input) => {
    return $input.is('[type="checkbox"]');
};
export const isRadio = ($input) => {
    const $radioInput = getRadioInput($input);
    return $radioInput.is('[type="radio"]');
};
export const getRadioInput = ($input) => {
    return $input.is('input') ? $input : $input.find('input').first();
};
export const clearInputValue = ($input) => {
    if (isCheckbox($input) || isRadio($input)) {
        $input.prop('checked', false);
    }
    else {
        $input.val('');
    }
    $input.trigger('change');
};
export const disableAllInputs = ($container, disableButtons = false) => {
    const $inputs = $container.find(`input, select, textarea${disableButtons ? ', button' : ''}`);
    $inputs.each((index, element) => {
        disableInput($(element));
    });
};
export const enableAllInputs = ($container, disableButtons = false) => {
    const $inputs = $container.find(`input, select, textarea${disableButtons ? ', button' : ''}`);
    $inputs.each((index, element) => {
        enableInput($(element));
    });
};
export const disableInput = ($input) => {
    const $formGroup = $input.closest('.form-group');
    $formGroup.find('label').addClass('disabled');
    $formGroup.find('legend').addClass('disabled');
    $input.prop('disabled', true);
};
export const enableInput = ($input) => {
    const $formGroup = $input.closest('.form-group');
    $formGroup.find('label').removeClass('disabled');
    $formGroup.find('legend').removeClass('disabled');
    $input.prop('disabled', false);
};
